import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import TextArea from '../../../components/formControls/Textarea';
import {
  calculateSMSNumber,
  SMS_MAX_SMS_SENT_LENGTH,
  SMS_TOTAL_CHARS_LENGTH,
} from '../../../js/sms/SMSUtils';

const messages = defineMessages({
  placeholderInfo: {
    id: 'SMSTextArea.placeholderInfo',
    defaultMessage: 'You can insert a placeholder that will be replaced with name of the contact by digiting {nome} in the message text.',
  },
  usedChars: {
    id: 'SMSTextArea.usedChars',
    defaultMessage: 'Used chars:',
  },
  messages: {
    id: 'SMSTextArea.messages',
    defaultMessage: 'Messages:',
  },
  totalChars: {
    id: 'SMSTextArea.totalChars',
    defaultMessage: 'Total chars:',
  },
});

const SMSTextArea = ({
  error,
  text,
  onChange,
  placeholderLength,
  onBlur,
  campaign,
  intl: { formatMessage },
}) => {
  return (
    <>
      <TextArea
        rows={6}
        onChange={onChange}
        onBlur={onBlur}
        value={text}
        error={error}
        id="SMStext"
        name="SMStext"
      />
      {campaign && (
        <div>
          <span className='small text-muted'>
            {formatMessage(messages.placeholderInfo)}
          </span>
        </div>
      )}
      <div>
        <span>
          {` ${formatMessage(messages.usedChars)} ${
            text ? text.length + placeholderLength : 0
          } / ${SMS_TOTAL_CHARS_LENGTH}`}
        </span>
        <span className="ml-2">
          {` ${formatMessage(messages.messages)} ${
            text ? calculateSMSNumber(text, placeholderLength) : '1'
          } / ${SMS_MAX_SMS_SENT_LENGTH}`}
        </span>
      </div>
    </>
  );
};

SMSTextArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  text: PropTypes.string,
  error: PropTypes.string,
  placeholderLength: PropTypes.number,
  campaign: PropTypes.bool,
};

SMSTextArea.defaultProps = {
  onBlur: null,
  text: '',
  error: '',
  placeholderLength: 0,
  campaign: false,
};

export default injectIntl(SMSTextArea);
